<script>
  import { _ } from "svelte-i18n"
  import { modals } from '../stores';
  import { createEventDispatcher } from 'svelte';
  import { previews_nav_filters, business_subscription_deactivated, pro_subscription_deactivated } from "../stores";
  import Button from '../elements/Button.svelte';

  export let in_page = false

  const dispatch = createEventDispatcher()

  function openUpgradeToBusinessModal() {
    modals.open('upgrade_to_business')
    if (typeof window.gtag == "undefined") return
    gtag('event', 'upgrade_to_business_modal_shown', {
      'initiator': 'storefront_actions'
    });
  }

  function openSubscribeModal() {
    modals.open('buy')
    if (typeof window.gtag == "undefined") return
    gtag('event', 'buy_modal_shown', {
      'initiator': 'business_upsell_notice'
    });
  }
  
</script>

<div class="BusinessUpsellNotice" class:in_page={in_page}>
  {#if $previews_nav_filters.storefront}
    {#if $business_subscription_deactivated}
      <p>Your Business subscription has expired. Please subscribe to the Business plan to continue using Storefronts.</p>
    {:else}
      <p>Storefronts are available with the new Business plan.{@html in_page ? "<br>" : " "}You can try it out now and upgrade when you're ready to share with customers.</p>
    {/if}
  {:else}
    {#if $business_subscription_deactivated}
      <p>Your Business subscription has expired. Please subscribe to the Business plan to continue using your uploaded fonts.</p>
    {:else}
      <p>Uploaded fonts are available with the new Business plan.{@html in_page ? "<br>" : " "}You can try it with a limited number of fonts and upgrade when you're ready to upload more.</p>
    {/if}
  {/if}
  <div class="right">
    {#if $business_subscription_deactivated || $pro_subscription_deactivated}
      <Button kind={in_page ? "accent-orange" : "outline-accent-orange"} size={in_page ? "normal" : "small"} on_warning={!in_page} on:click={openSubscribeModal}>
        {@html $_('buttons.subscribeTo')} <b>{$_('app.businessName')}</b>
      </Button>
    {:else}
      {#if in_page}
        <div class="button-group">
          {#if $previews_nav_filters.storefront}
            <Button on:click={() => dispatch('create_storefront')}>Create a test storefront</Button> or 
          {/if}
          <Button kind="accent-orange" size="normal" on_warning={false} on:click={openUpgradeToBusinessModal}>
            {@html $_('buttons.upgradeTo')} <b>{$_('app.businessName')}</b>
          </Button>
        </div>
      {:else}
        <Button kind="outline-accent-orange" size="small" on_fill={true} on:click={openUpgradeToBusinessModal}>
          {@html $_('buttons.upgradeTo')} <b>{$_('app.businessName')}</b>
        </Button>
      {/if}
    {/if}
  </div>
</div>

<style>
  .BusinessUpsellNotice {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-grow: 1;
    gap: 1.5rem;
    padding: 0.75rem 2rem;
    font-size: 1.6rem;
    background-color: var(--c-warning-bg);
    border: 1px solid var(--c-bg-a2);
    border-bottom-color: var(--c-pill-bg);
    color: var(--c-warning-text);
  }
  .right {
    margin-left: auto;
  }
  .BusinessUpsellNotice.in_page .right {
    margin-left: 0;
    margin-right: auto;
  }
  .right :global(button) {
    white-space: nowrap;
  }
  .BusinessUpsellNotice.in_page {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    margin-top: 3rem;
    padding: 0;
    max-width: 68rem;
    font-family: var(--PensumSans-Bold);
    color: var(--c-accent-orange);
    border-bottom: 0;
    background: none;
  }
  .BusinessUpsellNotice.in_page .right .button-group {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
  }
</style>